// extracted by mini-css-extract-plugin
export default {"roleplayInfoContainer":"RoleplayInfo_roleplayInfoContainer__HHV-T"};